var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRupee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.145,
    height: 23.643,
    viewBox: "0 0 16.145 23.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M13.475,14.241A5.507,5.507,0,0,1,11.448,17.4,10.045,10.045,0,0,1,8.138,19L16.21,29.643H10.671L5,22.043a9.367,9.367,0,0,0-1.773-1.908,2.756,2.756,0,0,0-1.672-.591h-.3v-2.8H3.241q.912,0,1.773-.084A6.832,6.832,0,0,0,6.6,16.318a3.838,3.838,0,0,0,1.283-.743,2.907,2.907,0,0,0,.827-1.334H.64l1.013-3.006H8.78A2.5,2.5,0,0,0,7.53,9.58a6.011,6.011,0,0,0-2.567-.574H.64L1.653,6H16.785L15.771,9.006H12.934a6.635,6.635,0,0,1,.709,2.229h3.141l-1.013,3.006Z",
    transform: "translate(-0.64 -6)",
    opacity: 0.448
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.a6a5934a058931bafddce75a76c107d9.svg";
export { ForwardRef as ReactComponent };